{
  "de": {
    "models": {
      "name": "Schiffe",
      "model": {
        "metrics": {
          "base": "Basis",
          "crew": "Besatzung",
          "info": "Info",
          "levels": "Ebenen",
          "speed": "Geschwindigkeit"
        },
        "focus": "Fokus",
        "classification": "Klassifizierung",
        "size": "Größe",
        "beam": "Breite",
        "cargo": "Fracht",
        "netCargo": "Fracht mit Rover/Snub",
        "crew": "Besatzung",
        "speed": "Geschwindigkeit",
        "minCrew": "min. Besatzung",
        "maxCrew": "max. Besatzung",
        "scmSpeed": "SCM Speed",
        "maxSpeed": "Max. Geschwindigkeit",
        "scm": "SCM",
        "max": "Max",
        "groundMaxSpeed": "Max. Geschwindigkeit",
        "groundReverseSpeed": "Rückwärtsgeschwindigkeit",
        "pitch": "Pitch",
        "yaw": "Yaw",
        "roll": "Roll",
        "price": "Preis",
        "groundAcceleration": "Beschleunigung",
        "groundDecceleration": "Verzögerung",
        "scmSpeedAcceleration": "Null auf SCM",
        "scmSpeedDecceleration": "SCM auf Null",
        "maxSpeedAcceleration": "Null auf Max",
        "maxSpeedDecceleration": "Max auf Null",
        "compare": {
          "groundMaxSpeed": "Max. Bodengeschwindigkeit",
          "groundReverseSpeed": "Rückwärts-Bodengeschwindigkeit",
          "groundAcceleration": "Bodenbeschleunigung",
          "groundDecceleration": "Bodenverzögerung"
        },
        "quantumFuelTankSize": "Quantum-Treibstoff",
        "hydrogenFuelTankSize": "Treibstoff",
        "pledgePrice": "Pledge-Preis",
        "height": "Höhe",
        "length": "Länge",
        "mass": "Masse",
        "manufacturer": "Hersteller",
        "hardpoints": "Aufhängungspunkte",
        "weapons": "Waffen",
        "equipment": "Ausrüstung",
        "variants": "Varianten",
        "maxUpgrades": "Upgrades",
        "productionStatus": "Produktionsstatus",
        "propulsion": "Antrieb",
        "ordnance": "Bewaffnung",
        "modular": "Modular",
        "soldAt": "Verkauft bei?",
        "rentalAt": "Gemietet bei?",
        "lastUpdatedAt": "Zuletzt aktualisiert am?",
        "loaners": "Leihschiffe",
        "paints": "Lackierungen",
        "modules": "Module",
        "modulePackages": "Modulpakete",
        "upgrades": "Upgrade-Kits",
        "brochure": "Broschüre",
        "onSale": "Im Angebot",
        "salesPage": "Verkaufsseite",
        "addons": "Module & Upgrade-Kits",
        "productionStatuses": {
          "notAvailable": "N/A",
          "in-production": "In Produktion",
          "in-concept": "Im Konzept",
          "ready": "Hangar-bereit",
          "flight-ready": "Flugbereit",
          "announced": "Angekündigt"
        }
      }
    }
  }
}
